
import React from 'react'
import { Button,Modal } from 'react-bootstrap'
import PopUpImg from '../Assets/Img/PopUpImg.jpg';
import "../Assets/Css/PopUp.css";
import {Link} from "react-router-dom";
import YouTube from 'react-youtube';

class PopUp extends React.Component{

    constructor(){
        super();
        this.state = {
            showHide : true
        }
    }

    handleModalShowHide() {
        this.setState({ showHide: !this.state.showHide })
    }

    render(){
      const opts = {
        height: '390',
        width: '640',
        playerVars: {
          autoplay: 1,
        },
      };
        return(
            <div>
                <Modal 
                
                show={false}
                >
                    <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
                    <Modal.Title>Anuncio</Modal.Title>
                    </Modal.Header>
                   
                    <p style={{'align-self': 'center', zoom: '35%'}}>
                        <img src={PopUpImg}/>    
                    </p>

       
                </Modal> 

                <Modal 
                style={{display: 'flex', 'justify-content': 'center'}}
                dialogClassName="modal-70w"
                show={false}>
                  <div style={{'background-color': '#84bc01', 'font-weight': 'bold'}}>
                    <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
                    <Modal.Title>¡Te esperamos en la Expo Rural!</Modal.Title>
                    </Modal.Header>
                  
                    <YouTube style={{display: 'flex','justify-content': 'center',}} videoId="svoqvb7yq6Y" opts={opts} />
                    <Modal.Body>Te esperamos en nuestro Stand ubicado en el Pabellón Verde, desde el 21 al 31 de Julio desde las 9h hasta las 21hs!</Modal.Body>
                    <Modal.Body>Te invitamos un café con nuestros expertos, chequeá la agenda!</Modal.Body>
                    <a style={{display: 'list-item', color: '#f8a700'}} 
                        href="https://www.instagram.com/art.mutualrural/" target="_blank">

                        <Button style={{'background-color': 'green'}} variant="secondary">
                        
                        <h6>Seguir el evento </h6>
                           
                        </Button>
                        </a>
                    <Modal.Footer>
                    </Modal.Footer>
                    </div>
                </Modal> 

            </div>
        )
    }
}

export default PopUp;